<app-header></app-header>

<div class="page-shell">
  <!-- HERO -->
  <section class="checkout-hero">
    <div class="hero-eyebrow">Enrollment</div>

    <h1>
      Complete Your<br />
      <em>NEXGEN Enrollment</em>
    </h1>

    <div class="hero-tagline">Be a Coach. Build a Business.</div>

    <div class="trust-row">
      <div class="trust-item">
        <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <rect x="3" y="11" width="18" height="11" rx="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        Secure Checkout
      </div>

      <div class="trust-item">
        <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        Instant Confirmation
      </div>

      <div class="trust-item">
        <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        Welcome Email Within Minutes
      </div>
    </div>
  </section>

  <!-- GUARANTEE BAR -->
  <section class="guarantee-bar">
    <div class="guarantee-tag">30-Day Money-Back Guarantee</div>
    <div class="guarantee-text">
      Join NEXGEN with confidence. If the program isn’t right for you, let us know within 30 days and we’ll refund your
      tuition.
    </div>
  </section>

  <!-- STEPS -->
  <section class="steps-bar">
    <div class="step active">
      <div class="step-num">1</div>
      <div class="step-label">Your Details</div>
    </div>

    <div class="step-divider"></div>

    <div class="step inactive">
      <div class="step-num">2</div>
      <div class="step-label">Payment & Confirmation</div>
    </div>
  </section>

  <!-- BODY -->
  <section class="checkout-body">
    <!-- INSTALLMENT TABS -->
    <div class="installment-tabs" *ngIf="showInstallmentTabs">
      <button *ngFor="let plan of installmentPlans" type="button" [class.active]="selectedPlan === plan.id"
        (click)="selectPlan(plan.id)" [attr.aria-label]="plan.label">
        {{ plan.label }}
      </button>
    </div>

    <div class="checkout-grid">
      <!-- LEFT: FORM -->
      <div class="form-panel">
        <div class="form-panel-header">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>Billing Details</span>
        </div>

        <div class="form-body">
          <p class="data-notice">
            Your personal data will be used to process your order securely and to communicate your enrollment details.
          </p>

          <form [formGroup]="billingForm" (ngSubmit)="onSubmit()">
            <div class="field-group-label">Your Information</div>

            <div class="field-row">
              <div class="field">
                <label>First Name</label>
                <input formControlName="firstName" type="text" placeholder="First name" />
                <span class="error"
                  *ngIf="billingForm.get('firstName')?.touched && billingForm.get('firstName')?.invalid">
                  First name is required
                </span>
              </div>

              <div class="field">
                <label>Last Name</label>
                <input formControlName="lastName" type="text" placeholder="Last name" />
                <span class="error"
                  *ngIf="billingForm.get('lastName')?.touched && billingForm.get('lastName')?.invalid">
                  Last name is required
                </span>
              </div>
            </div>

            <div class="field-row full">
              <div class="field">
                <label>Email Address</label>
                <input formControlName="email" type="email" placeholder="your@email.com" />
                <span class="error" *ngIf="billingForm.get('email')?.touched && billingForm.get('email')?.invalid">
                  {{
                  billingForm.get("email")?.hasError("required")
                  ? "Email is required"
                  : "Invalid email format"
                  }}
                </span>
              </div>
            </div>

            <div class="field-row full">
              <div class="field">
                <label>Country</label>

                <div class="country-select" [class.open]="showCountryDropdown">
                  <input type="text" formControlName="country" placeholder="Search and select country"
                    autocomplete="off" (focus)="openCountryDropdown()" (input)="filterCountries()" />

                  <button type="button" class="country-toggle" (click)="toggleCountryDropdown()" tabindex="-1"
                    aria-label="Toggle country list">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                      <path d="M2 2L7 7L12 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>

                  <div class="country-dropdown" *ngIf="showCountryDropdown">
                    <button type="button" class="country-option" *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)">
                      {{ country }}
                    </button>

                    <div class="country-empty" *ngIf="filteredCountries.length === 0">
                      No country found
                    </div>
                  </div>
                </div>

                <span class="error" *ngIf="billingForm.get('country')?.touched && billingForm.get('country')?.invalid">
                  Country is required
                </span>
              </div>
            </div>

            <div class="field-row full">
              <div class="field">
                <label>
                  Referral Code
                  <span class="optional-inline">(optional)</span>
                </label>
                <input formControlName="referralCode" type="text" placeholder="Enter referral code if you have one" />
              </div>
            </div>

             
<div class="field-row full">
  <div class="field">
    <div class="billing-terms-wrap">
      <label class="billing-terms-label">
 
        <div class="billing-checkbox-box">
          <input
            type="checkbox"
            formControlName="agreeToTerms"
            id="agreeToTerms"
          />
          <div class="billing-checkmark">
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
              <path
                d="M1 4.5L4 7.5L10 1"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
 
        <span class="billing-terms-text">
          I agree to the
          <a href="https://nexgencoaches.com/terms-and-conditions/" target="_blank" rel="noopener">
            Terms &amp; Conditions
          </a>
          and
          <a href="https://nexgencoaches.com/privacy-policy/" target="_blank" rel="noopener">
            Privacy Policy
          </a>
        </span>
 
      </label>
 
      <span
        class="billing-terms-error"
        *ngIf="billingForm.get('agreeToTerms')?.touched && billingForm.get('agreeToTerms')?.hasError('requiredTrue')"
      >
        You must agree to the terms to continue
      </span>
    </div>
  </div>
</div>
            <div class="payment-notice" *ngIf="!showInstallmentTabs && packagePrice !== 'Custom Pricing'">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <div>
                <strong>Full payment only</strong> — Installments are not available for this package.
              </div>
            </div>

            <div class="payment-notice" *ngIf="showInstallmentTabs && selectedPlan !== 'full'">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <div>
                <strong>Installment selected</strong> — {{ getTotalPrice() }}
              </div>
            </div>

            <button type="submit" class="pay-btn"
              [disabled]="billingForm.invalid || isLoading || packagePrice === 'Custom Pricing'" [attr.aria-label]="
                packagePrice === 'Custom Pricing'
                  ? 'Contact support for custom pricing'
                  : 'Proceed to payment'
              ">
              <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <rect x="3" y="11" width="18" height="11" rx="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>

              {{
              isLoading
              ? 'Processing...'
              : packagePrice === 'Custom Pricing'
              ? 'Contact Support'
              : 'Continue to Payment →'
              }}
            </button>

            <div class="pay-sub">
              <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <rect x="3" y="11" width="18" height="11" rx="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              You’ll be redirected to our secure payment page to complete your enrollment
            </div>
          </form>
        </div>
      </div>

      <!-- RIGHT: SUMMARY -->
      <div class="summary-panel">
        <!-- PROGRAM CARD -->
        <div class="program-card">
          <div class="program-card-top">
            <div class="program-label">You Are Enrolling In</div>
            <div class="program-name">
              {{ packageName }}
              <span class="campaign-name" *ngIf="activeDiscountCampaign">
                ({{ activeDiscountCampaign.campaignName }})
              </span>
            </div>

            <div *ngIf="packagePrice !== 'Custom Pricing'; else customPriceTpl">
              <div class="program-price-wrap" *ngIf="isDiscountApplied; else normalPriceTpl">
                <div class="program-old-price">
                  {{ getOriginalPriceDisplay() }}
                </div>

                <div class="program-discount-row">
                  <div class="program-price">
                    ${{ formatMainPrice(finalPackagePrice) }}
                  </div>

                  <span class="discount-badge" *ngIf="getDiscountBadge()">
                    {{ getDiscountBadge() }}
                  </span>
                </div>

                <div class="program-savings" *ngIf="discountAmount > 0">
                  You save {{ getSavingsDisplay() }}
                </div>
              </div>

              <ng-template #normalPriceTpl>
                <div class="program-price">
                  ${{ formatMainPrice(packagePrice) }}
                </div>
              </ng-template>
            </div>

            <ng-template #customPriceTpl>
              <div class="program-price">
                Custom
              </div>
            </ng-template>

            <div class="program-price-note">
              {{ packageSubtitle || getPlanDuration() }}
            </div>

            <div class="program-card-body">
              <ul class="program-includes" *ngIf="packageBullets?.length; else noBullets">
                <li *ngFor="let bullet of packageBullets">
                  <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  <span [innerHTML]="bullet"></span>
                </li>
              </ul>

              <ng-template #noBullets>
                <ul class="program-includes">
                  <li>
                    <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"
                      viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Premium coaching education experience
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>

          <!-- TOTALS -->
          <div class="totals-card">
            <div class="totals-card-title">Order Summary</div>

            <div class="totals-row">
              <span class="t-label">{{ packageName || 'Package' }}</span>

              <span class="t-val" *ngIf="packagePrice === 'Custom Pricing'">
                Custom Pricing
              </span>

              <span class="t-val t-val--stack" *ngIf="packagePrice !== 'Custom Pricing'">
                <span class="summary-old-price" *ngIf="isDiscountApplied">
                  {{ getOriginalPriceDisplay() }}
                </span>
                <span>{{ getFinalPriceDisplay() }}</span>
              </span>
            </div>

            <div class="totals-row" *ngIf="isDiscountApplied && discountAmount > 0">
              <span class="t-label">Campaign Discount</span>
              <span class="t-val savings-val">-{{ getSavingsDisplay() }}</span>
            </div>

            <div class="totals-row">
              <span class="t-label">Plan</span>
              <span class="t-val">{{ getPlanDuration() }}</span>
            </div>

            <div class="totals-total">
              <span class="tt-label">Total</span>
              <span class="tt-amount">
                {{ getDisplayTotal() }}
              </span>
            </div>

            <!-- <div class="coupon-row">
    <input formControlName="couponCode" [formGroup]="billingForm" type="text" placeholder="Enter coupon code" />
    <button type="button" class="coupon-btn" (click)="applyCoupon()" [disabled]="isLoading">
      Apply
    </button>
  </div> -->
          </div>

          <!-- GUARANTEE CARD -->
          <div class="mini-guarantee-card">
            <div class="guarantee-icon">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>

            <div class="guarantee-card-text">
              <strong>30-Day Money-Back Guarantee</strong>
              <p>
                If the program isn’t the right fit, contact us within 30 days of your start date and we will refund your
                full tuition.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<app-bottomside></app-bottomside>